import Bottle from 'bottlejs';
import mediaBrowserContainerFactory from './MediaBrowserContainer';
import mediaBrowserDataFactory from './MediaBrowserData';
import mediaBrowserViewFactory from './MediaBrowserView';

export default () => {
  const MediaBrowserBottle = new Bottle();
  mediaBrowserContainerFactory(MediaBrowserBottle);
  mediaBrowserDataFactory(MediaBrowserBottle);
  mediaBrowserViewFactory(MediaBrowserBottle);
  return MediaBrowserBottle;
};
